import { useState } from "react";

const useTrueFalse = () => {
  const [isTrue, setIsTrue] = useState(false);

  return { isTrue, setIsTrue };
};

export default useTrueFalse;
